<template>
    <Card :header="$t('logs')" class="m-0 shadow-none h-100">
        <DataTable
            :fields="fields"
            :items="items"
            :loading="loading"
            :error="error"
            :total-rows="requestData.max"
            :current-page.sync="tableParams.page"
            :per-page.sync="tableParams.perPage"
            :sort-by.sync="tableParams.sort"
            :sort-direction.sync="tableParams.order"
            no-sort-reset
            no-local-sorting
        >
            <template #cell(timestamp)="{ item }">
                {{ $format.dateTime(item.timestamp) }}
            </template>
            <template #cell(updatedAt)="{ item }">
                {{ $format.dateTime(item.updatedAt) }}
            </template>
        </DataTable>
    </Card>
</template>

<script>
    import Card from '@/components/common/Card.vue';
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'Logs',
        components: {
            Card,
            DataTable,
        },
        data() {
            return {
                requestData: {
                    max: 0,
                    items: [],
                },
                tableParams: {
                    page: 1,
                    perPage: 10,
                    sort: 'timestamp',
                    order: 'desc',
                },
                loading: false,
                error: null,
            };
        },
        computed: {
            offerId() {
                return Number(this.$route.params.id);
            },
            items() {
                return this.requestData?.items;
            },
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'updatedAt', label: this.$t('updatedAt') },
                    { key: 'lastInFeedAt', label: this.$t('lastInFeedAt') },
                    { key: 'url', label: this.$t('url') },
                    { key: 'ean', label: this.$t('ean') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'info', label: this.$t('info') },
                    { key: 'code', label: this.$t('code') },
                    { key: 'price', label: this.$t('price') },
                    { key: 'feed', label: this.$t('feed') },
                    { key: 'offerId', label: this.$t('offerId') },
                    { key: 'source', label: this.$t('source') },
                    { key: 'availability', label: this.$t('availability') },
                    { key: 'active', label: this.$t('active') },
                    { key: 'hidden', label: this.$t('hidden') },
                    { key: 'type', label: this.$t('type') },
                ];
            },
        },
        watch: {
            tableParams: {
                deep: true,
                immediate: true,
                handler() {
                    this.fetchLogs();
                },
            },
        },
        methods: {
            async fetchLogs() {
                this.loading = true;
                this.error = null;
                try {
                    const data = await this.$req('offers/offerLogs').get({
                        urlParams: { offerId: this.offerId },
                        query: {
                            page: this.tableParams.page,
                            perPage: this.tableParams.perPage,
                            sort: this.tableParams.sort,
                            order: this.tableParams.order,
                        },
                    });

                    this.requestData = data;
                } catch (err) {
                    this.error = err;
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
